import React, { Fragment } from "react";
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faMinus } from '@fortawesome/free-solid-svg-icons'

const Transfer = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchTransferencias()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <tr>
                <td>{props.transfer.origem}</td>
                <td>{props.transfer.competencia}</td>
                <td>{props.transfer.ano}</td>
                <td>{props.transfer.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</td>
                <td>{props.transfer.tipo}</td>
                <td>{props.transfer.programa ? props.transfer.programa : "Não se aplica"}</td>
                <td>{props.transfer.destinatario}</td>
                <td><FontAwesomeIcon onClick={() => editar(props.transfer._id)} className="icon-cad" icon={faPen} /></td>
                <td><FontAwesomeIcon onClick={() => deletar(props.transfer._id)} className="icon-cad" icon={faMinus} /></td>
            </tr>
        </Fragment >)
}

export default Transfer;